import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/_services/auth.service';
import {
  iconAnimation,
  labelAnimation, sidebarAnimation } from '../../animations/animations';
import { SidebarService } from '../../services/sidebar.service';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    sidebarAnimation(),
    iconAnimation(),
    labelAnimation(),
  ]
})
export class SidebarComponent implements OnInit {
  sidebarState: string = '';
  user = this.authService.getClientUser();

  navigations = [
    {
      title: 'Opšte',
      routes: [
        {
          title: 'Vozila',
          icon: 'fa fa-bus',
          path: '/vehicles'
        },
        {
          title: 'Podkorisnici',
          icon: 'fa fa-users',
          path: '/clientSubusers'
        },
        {
          title: 'Servisna knjiga',
          icon: 'fa fa-book',
          path: '/serviceBooks'
        }
      ]
    },
    {
      title: 'Analiza',
      routes: [
        {
          title: 'Kretanje',
          icon: 'moving',
          path: '/vehicleMovements'
        },
        {
          title: 'Zadržavanje',
          icon: 'fa fa-anchor',
          path: '/delays'
        },
        {
          title: 'Rad na leru',
          icon: 'fa fa-cogs',
          path: '/ler'
        },
        {
          title: 'Prekoračenje brzine',
          icon: 'speeding',
          path: '/speeding'
        },
        {
          title: 'Promena količine goriva',
          icon: 'fuel',
          path: '/fueling'
        }
      ]
    },
    {
      title: 'Putarina',
      routes: [
        {
          title: 'Srbija',
          icon: 'fa fa-road',
          path: '/clientSrbTolls/vehicles'
        }
      ]
    },
    {
      title: 'Administracija',
      routes: [
        {
          title: 'Radno/neradno vreme',
          icon: 'fa fa-briefcase',
          path: '/workingHourReports'
        },
        {
          title: 'Automatski izveštaji',
          icon: 'fa fa-file-text',
          path: '/automaticReports'
        },
        {
          title: 'Vozači',
          icon: 'fa fa-street-view',
          path: '/drivers'
        },
        {
          title: 'Geofencing',
          icon: 'fa fa-globe',
          path: '/geofencings'
        },
        {
          title: 'Integracije',
          icon: 'fa fa-cog',
          path: '/integrations'
        },

        {
          title: 'POI',
          icon: 'fa fa-map-marker',
          path: '/point-of-interest'
        }
      ]
    },
    {
      title: `Ostalo (${this.user?.firstName})`,
      routes: [
        {
          title: 'Odjavi se',
          icon: 'fa fa-sign-out',
          path: '/login'
        }
      ]
    }
  ]

  constructor(
    private sidebarService: SidebarService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.sidebarService.sidebarStateObservable$.
      subscribe((newState: string) => {
        this.sidebarState = newState;
      });
  }

  toggleSideNav() {
    this.sidebarService.toggle();
  }
}
